export default class LocationConsts {
    static readonly Language = 'en';
}
